const SERVICE_NAMES = {
    'IPIPELINE': 'iPipeline',
};

export function serviceName(service) {
    return SERVICE_NAMES[service] || service;
}